import React from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import { Link } from "react-router-dom"

const ConditionalLink = ({
    to,
    isExternal,
    className,
    onClick,
    openInNewTab,
    children,
    isFragment,
    label,
    role,
}) => {
    const navigate = useNavigate()

    const onClickHandler = (event) => {
        if (typeof onClick === "function") {
            onClick(event)
        }
    }
    if (to) {
        if (isExternal) {
            return (
                <a
                    href={to}
                    className={className}
                    onClick={(event) => {
                        // Check for Ctrl+Click (Windows/Linux) or Cmd+Click (Mac)
                        const isModifierClick = event.ctrlKey || event.metaKey
                        if (isModifierClick) {
                            onClickHandler(event)
                            window.open(to, "_blank", "noopener,noreferrer")
                            event.preventDefault()
                            return
                        }
                        onClickHandler(event)
                    }}
                    target={openInNewTab ? "_blank" : ""}
                    rel="noreferrer noopener nofollow"
                    aria-label={label}
                >
                    {children}
                </a>
            )
        }
        return (
            <Link
                to={to}
                className={className}
                onClick={(event) => {
                    // Check for Ctrl+Click (Windows/Linux) or Cmd+Click (Mac)
                    const isModifierClick = event.ctrlKey || event.metaKey
                    if (isModifierClick) {
                        onClickHandler(event)
                        const currentOrigin = window.location.origin
                        const fullUrl = to.startsWith("/") ? `${currentOrigin}${to}` : to
                        window.open(fullUrl, "_blank", "noopener,noreferrer")
                        event.preventDefault()
                        return
                    }
                    //we doing this to prevent Link component internal navigation mechanism
                    //and we are doing the navigation on our own with useNavigate
                    onClickHandler(event)
                    if (!event.defaultPrevented) {
                        event.preventDefault()
                        navigate(to)
                    }
                }}
                aria-label={label}
            >
                {children}
            </Link>
        )
    } else {
        //This case is to ensure that when classnames are passed to a fragment it gets turned into a div instead
        if (isFragment && className) {
            return <div className={className}>{children}</div>
        } else if (isFragment) {
            return <>{children}</>
        } else {
            return (
                <div
                    className={className}
                    onClick={onClickHandler}
                    role={role || "link"}
                    tabIndex={0}
                    aria-label={label}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault()
                            onClickHandler(e)
                        }
                    }}
                >
                    {children}
                </div>
            )
        }
    }
}

ConditionalLink.propTypes = {
    to: PropTypes.string,
    isExternal: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
    openInNewTab: PropTypes.bool,
    children: PropTypes.node.isRequired,
    isFragment: PropTypes.bool,
    label: PropTypes.string,
    role: PropTypes.string,
}

export default ConditionalLink
